// src/pages/AdminLetters.jsx
import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import './AdminLetters.css';

function AdminLetters() {
  const [letters, setLetters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllLetters = async () => {
      const { data, error } = await supabase
        .from('letters')
        .select('id, name, message, created_at, is_private')
        .order('created_at', { ascending: false });

      if (!error) {
        setLetters(data);
      }
      setLoading(false);
    };

    fetchAllLetters();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('이 편지를 삭제하시겠습니까?')) {
      const { error } = await supabase.from('letters').delete().eq('id', id);
      if (error) {
        alert('삭제 중 오류가 발생했습니다.');
      } else {
        setLetters(letters.filter((l) => l.id !== id));
      }
    }
  };

  return (
    <main className="letter-list">
      <h2 className="letter-list-title">(관리자) 모든 편지</h2>
      {loading ? (
        <p className="letter-list-loading">불러오는 중...</p>
      ) : (
        <ul className="letter-items">
          {letters.map((letter) => (
            <li key={letter.id} className="letter-item">
              <div className="letter-meta">
                <span className="letter-name">{letter.name || 'Kage'}</span>
                <span className="letter-date">
                  {new Date(letter.created_at).toLocaleString('ko-KR')}
                </span>
                {letter.is_private && <span className="letter-private-label">비공개</span>}
              </div>
              <p className="letter-message">{letter.message}</p>
              <button className="delete-letter-btn" onClick={() => handleDelete(letter.id)}>
                삭제
              </button>
            </li>
          ))}
        </ul>
      )}
    </main>
  );
}

export default AdminLetters;
